<template>
    <div>
        <!-- Modal Fechamentos Particulares -->
        <div class="modal fade" id="fechamentoParticularModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-dialog-scrollable modal-xl" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Fechamentos / Recebimentos</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body" v-if="lista">
                        <div class="card" v-for="(item, iix) in lista" :key="iix">
                            <div class="card-header d-flex justify-content-between">
                                <div>
                                    Lançamento #{{ item.id_lancamento }}
                                    <div class="small text-muted">
                                        {{ item.st_descricao }}
                                    </div>
                                </div>
                                <div>
                                    {{ $util.formatMoeda(item.dc_valor) }}
                                </div>
                            </div>
                            <ul class="list-group">
                                <li class="list-group-item d-flex justify-content-between" v-for="(fechamento, ifx) in item.fechamento_particular_items" :key="ifx">
                                    <div v-if="fechamento.fechamento">
                                        {{ $util.getFormatDate(fechamento.fechamento.created_at) }}
                                        {{ fechamento.fechamento.created_at.slice(11,16) }}
                                        <span class="ml-3">
                                            {{ fechamento.fechamento.usuario.st_login }}
                                        </span>
                                        <span class="badge badge-secondary ml-3" title="Id">
                                            #{{ fechamento.id_fechamento_particular }}
                                        </span>
                                        <span class="badge ml-3" :class="'badge-' + ( fechamento.fechamento.cor ? fechamento.fechamento.cor : 'dark' )" title="Tipo">
                                            {{ fechamento.fechamento.tipo }}
                                        </span>
                                        <span class="ml-3 small text-muted" v-if="fechamento.fechamento.st_obs">
                                            {{ fechamento.fechamento.st_obs }}
                                        </span>
                                    </div>
                                    <div>
                                        <span class="badge badge-secondary" v-if="fechamento.items_count > 0">
                                            {{ fechamento.items_count }}
                                        </span>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';

export default {
    data() {
        return { 
            lista: null, 
        };
    },

    methods: { 
        abrir(lista) { 
            this.lista = _.cloneDeep(lista); 
            $('#fechamentoParticularModal').modal('show');
        }
    }
}
</script>
